import {
  Avatar,
  AvatarFallbackText,
  AvatarImage,
} from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { Text } from "@/components/ui/text";
import { Heading } from "@/components/ui/heading";
import { VStack } from "@/components/ui/vstack";
import { ParticipantDTO } from "@/generated/api/models";
import { getName } from "@/utils/name";
import { HStack } from "@/components/ui/hstack";
import { Icon } from "@/components/ui/icon";
import { ChevronRight } from "lucide-react-native";
import { useMemo } from "react";
import { Badge, BadgeText } from "@/components/ui/badge";
import { cn } from "@gluestack-ui/nativewind-utils/cn";

export function RestaurantTeamItemMini({
  participant,
  variant = "full",
}: {
  participant: ParticipantDTO;
  variant?: "full" | "short";
}) {
  const name = getName(participant.user);

  const uniqueTags = useMemo(
    () => [...new Set([...participant.publicTags, ...participant.privateTags])],
    [participant.privateTags, participant.publicTags]
  );
  const size = variant === "full" ? "md" : "sm";
  const secondarySize = variant === "full" ? "sm" : "xs";
  const thirtierSize = variant === "full" ? "xs" : "2xs";

  return (
    <Card
      size={size}
      variant="filled"
      className={cn("flex-row justify-between w-full items-center", {
        "bg-transparent": variant === "short",
      })}
    >
      <HStack className="gap-4 items-center">
        <Avatar size={size} className="border-2 border-outline-0">
          <AvatarFallbackText>{name}</AvatarFallbackText>
          <AvatarImage
            source={{ uri: participant.user.avatarImage ?? undefined }}
          />
        </Avatar>
        <VStack className="gap-0">
          <Heading
            size={secondarySize}
            className="text-ellipsis overflow-hidden whitespace-nowrap"
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {name}
          </Heading>
          {uniqueTags.length > 0 ? (
            <HStack className="gap-2">
              {uniqueTags.map((t) => (
                <Badge key={t} action="info">
                  <BadgeText>{t}</BadgeText>
                </Badge>
              ))}
            </HStack>
          ) : (
            <Text size={thirtierSize}>(No tags assigned)</Text>
          )}
        </VStack>
      </HStack>

      {variant === "full" && <Icon as={ChevronRight} />}
    </Card>
  );
}
